if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
        this.notifyButtons = document.querySelectorAll('.NotifyMe');

        // Add event listener to each notify button
        this.notifyButtons.forEach(button => {
          button.addEventListener('click', this.notifyPopup.bind(this));
        });
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      notifyPopup() {
        var popup = document.querySelector('#notify-popup');
        var overlay = document.querySelector('.modal-overlay');
        popup.style.display = "flex"
        var variant_id = this.currentVariant.value;
        var form = popup.querySelector('.js-back-in-stock');
        var emailInput = popup.querySelector('input[name="email"]');
        overlay.style.display = "block";
        document.body.style.overflow = 'hidden';
        emailInput.value = " ";
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          const formData = new FormData(form);
          var options = {
            method: 'POST',
            headers: {
              accept: 'application/json',
              revision: '2024-07-15',
              'content-type': 'application/json'
            },
            body: JSON.stringify({
              data: {
                type: 'back-in-stock-subscription',
                attributes: {
                  channels: ['EMAIL'],
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: formData.get("email")
                      }
                    }
                  }
                },
                relationships: {
                  variant: {
                    data: {
                      type: 'catalog-variant',
                      id: '$shopify:::$default:::' + variant_id
                    }
                  }
                }
              }
            })
          };
          fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=TDJQX6', options)
            .then(response => response)
            .then(response => {
              // console.log(response)
              if (response.status) {
                emailInput.value = "you’ll receive an email when your size is back ✓";
                setTimeout(() => {
                  popup.style.display = "none";
                  overlay.style.display = "none";
                  document.body.style.overflow = '';
                }, 3000);
              }
            })
            .catch(err => console.error(err));
        });
        var close_btn = popup.querySelector('.close-popup');
        close_btn.addEventListener("click", () => {
          popup.style.display = "none";
          overlay.style.display = "none";
          document.body.style.overflow = '';
        })

      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
        this.input.min = min;

        if (max) {
          this.input.max = max;
        } else {
          this.input.removeAttribute('max');
        }
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

const qty_input = document.querySelector('.quantity__input');
qty_input.addEventListener('keyup', function (event) {
  let input = event.target;
  if (input.value.charAt(0) === '0') {
    input.value = '1' + input.value.slice(1);
  }
});